import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Lock, GraduationCap, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import axios from 'axios';

const tb = { fontFamily: "'Tiro Bangla', serif" };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) { setError('পাসওয়ার্ড দুটি মিলছে না'); return; }
        if (password.length < 6) { setError('পাসওয়ার্ড কমপক্ষে ৬ অক্ষর হতে হবে'); return; }
        setLoading(true); setError('');
        try {
            await axios.post(`${API}/auth/reset-password/${token}`, { password });
            setDone(true);
        } catch (err) {
            setError(err.response?.data?.detail || 'কিছু একটা ভুল হয়েছে। Link টি expire হয়ে গেছে কিনা দেখুন।');
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50 relative overflow-hidden">
            <div className="absolute top-[-150px] right-[-100px] w-[350px] h-[350px] rounded-full opacity-20 blur-3xl"
                style={{ background: 'radial-gradient(circle, #A855F7, #DB2777)' }} />
            <div className="w-full max-w-sm relative z-10">
                <div className="text-center mb-6">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-lg bg-gradient-to-br from-purple-600 to-pink-600">
                        <GraduationCap className="w-7 h-7 text-white" />
                    </div>
                    <h1 className="text-xl font-bold text-gray-800" style={tb}>নতুন পাসওয়ার্ড সেট করুন</h1>
                </div>

                <div className="relative">
                    <div className="absolute -inset-[1px] rounded-2xl bg-gradient-to-br from-purple-500 via-pink-500 to-purple-500 opacity-60 blur-[1px]" />
                    <div className="relative bg-white rounded-2xl shadow-xl p-6">
                        {done ? (
                            <div className="text-center space-y-4">
                                <CheckCircle className="w-12 h-12 text-green-500 mx-auto" />
                                <p className="font-semibold text-gray-800" style={tb}>পাসওয়ার্ড সফলভাবে পরিবর্তন হয়েছে!</p>
                                <Button className="w-full rounded-full bg-gradient-to-r from-purple-600 to-pink-600 text-white"
                                    onClick={() => navigate('/login')}>
                                    Login করুন
                                </Button>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} className="space-y-4">
                                {error && <p className="text-xs text-red-500 bg-red-50 px-3 py-2 rounded-lg" style={tb}>{error}</p>}
                                <div className="space-y-2">
                                    <Label style={tb} className="text-sm text-gray-600">নতুন পাসওয়ার্ড</Label>
                                    <div className="relative">
                                        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-300" />
                                        <Input type="password" placeholder="নতুন পাসওয়ার্ড"
                                            value={password} onChange={e => setPassword(e.target.value)}
                                            className="pl-10 rounded-xl border-gray-200" required minLength={6} />
                                    </div>
                                </div>
                                <div className="space-y-2">
                                    <Label style={tb} className="text-sm text-gray-600">পাসওয়ার্ড নিশ্চিত করুন</Label>
                                    <div className="relative">
                                        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-300" />
                                        <Input type="password" placeholder="আবার দিন"
                                            value={confirm} onChange={e => setConfirm(e.target.value)}
                                            className="pl-10 rounded-xl border-gray-200" required />
                                    </div>
                                </div>
                                <Button type="submit" disabled={loading}
                                    className="w-full rounded-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold py-3 hover:opacity-90 transition-all">
                                    {loading ? 'অপেক্ষা করুন...' : 'পাসওয়ার্ড পরিবর্তন করুন'}
                                </Button>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
